import { useMutation } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';
import { EmploymentStatus } from 'hooks/webapi/useClient';

function useClientEmploymentMutation() {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useMutation<
    {
      rejected: boolean;
    },
    unknown,
    UseClientEmploymentMutationOptions
  >({
    mutationFn: async (payload) => {
      try {
        const resp = await fetchData('/client/employment', {
          method: 'put',
          body: JSON.stringify(payload),
        });

        return resp;
      } catch (e) {
        error('[useClientEmployerMutation][PUT /client/employer]', e);
        showError();
        throw e;
      }
    },
  });
}

export type UseClientEmploymentMutationOptions = {
  employmentStatus: EmploymentStatus;
  employmentDetail?: string;
};

export default useClientEmploymentMutation;
